import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  getListRecruitmentPositionStart,
  getListRecruitmentPositionSuccess,
  getListRecruitmentPositionFailed,
} from "../redux/getListRecruitmentPosition";
import { toast } from "react-toastify";
import { getListRecruitmentPositionApi } from "core/http/service/recruitment";

function* getListRecruitmentPositionWork(
  action: ReturnType<typeof getListRecruitmentPositionStart>
) {
  const params = action.payload;
  try {
    const res = yield call(getListRecruitmentPositionApi, params);
    yield put({
      type: getListRecruitmentPositionSuccess.type,
      payload: res,
    });
  } catch (error) {
    yield put({
      type: getListRecruitmentPositionFailed.type,
    });
    toast.error("Đã có lỗi xảy ra!");
  }
}

function* watchGetListRecruitmentPosition() {
  yield takeLatest(
    getListRecruitmentPositionStart.type,
    getListRecruitmentPositionWork
  );
}
export default function* getListRecruitmentPositionSaga() {
  yield all([watchGetListRecruitmentPosition()]);
}
